import React from 'react';

import classnames from 'classnames';
import * as styles from './PeriodicityPicker.module.scss';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';

export type PeriodicityPickerProps = {
  periodicityOptions: Periodicity[];
  selectedPeriodicity: Periodicity;
  selectPeriodicityCallback: (periodicity: Periodicity) => void;
  disabledPeriodicityOptions: Periodicity[];
};

type ItemProps = {
  isActive: boolean;
  isDisabled: boolean;
  periodicity: Periodicity;
  selectPeriodicityCallback: (periodicity: Periodicity) => void;
};

const shouldDisablePeriodicity = (periodicity: Periodicity, blacklist: Periodicity[]) => {
  return blacklist.includes(periodicity);
};

const Item: React.FC<ItemProps> = ({ isActive, isDisabled, periodicity, selectPeriodicityCallback }) => (
  <li
    className={classnames(styles.TimeFrames__List__Option, {
      [styles['TimeFrames__List__Option--active']]: isActive,
      [styles['TimeFrames__List__Option--disabled']]: isDisabled,
    })}
    data-testid={`timeFrameOption${isActive ? '-active' : ''}${isDisabled ? '-disabled' : ''}`}
  >
    <button
      onClick={isActive || isDisabled ? () => {} : () => selectPeriodicityCallback(periodicity)}
      disabled={isDisabled}
    >
      {periodicity}
    </button>
  </li>
);

const PeriodicityPicker: React.FC<PeriodicityPickerProps> = ({
  periodicityOptions,
  selectedPeriodicity,
  selectPeriodicityCallback,
  disabledPeriodicityOptions,
}) => {
  const isCustomOptionAvailable =
    periodicityOptions.includes(Periodicity.CustomMonths) || periodicityOptions.includes(Periodicity.CustomWeeks); //NOSONAR typescript:S6606
  return (
    <ul className={styles.TimeFrames__List}>
      {periodicityOptions
        .filter((periodicity) => ![Periodicity.CustomMonths, Periodicity.CustomWeeks].includes(periodicity))
        .map((periodicity) => {
          const isDisabled = shouldDisablePeriodicity(periodicity, disabledPeriodicityOptions);

          return (
            <Item
              key={periodicity}
              isDisabled={isDisabled}
              isActive={periodicity === selectedPeriodicity}
              periodicity={periodicity}
              selectPeriodicityCallback={selectPeriodicityCallback}
            />
          );
        })}
      {isCustomOptionAvailable && (
        <>
          <div className={styles.TimeFrames__Divider} />
          {periodicityOptions
            //future implementation of Custom Weeks, just add inside filter
            .filter((periodicity) => [Periodicity.CustomMonths, Periodicity.CustomWeeks].includes(periodicity))
            .map((periodicity) => {
              const isDisabled = shouldDisablePeriodicity(periodicity, disabledPeriodicityOptions);

              return (
                <Item
                  key={periodicity}
                  isDisabled={isDisabled}
                  isActive={periodicity === selectedPeriodicity}
                  periodicity={periodicity}
                  selectPeriodicityCallback={selectPeriodicityCallback}
                />
              );
            })}
        </>
      )}
    </ul>
  );
};

export default PeriodicityPicker;
